export default __webpack_public_path__ + "static/mainImg-46efd34e4d847c6629bdf98ba47664ea.png";